import request from './request';

// 获取轮播图信息
export const getSwiper = params => {
    return request({
        url: '/index/index/swiper',
        method: 'GET',
        params
    })
};

// 获取新闻-列表
export const getNewsList = params => {
    return request({
        url: '/index/index/news',
        method: 'GET',
        params
    })
};

// 获取新闻-详情
export const getNewsDetail = params => {
    return request({
        url: '/index/index/detail',
        method: 'GET',
        params
    })
}

// 提交预约信息
export const savaAppointment = params => {
    return request({
        url: '/index/index/savaAppointment',
        method: 'POST',
        params
    })
}